export default __webpack_public_path__ + "static/media/Setting_DreamlessUS.ed302d53.svg";